import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IDealDocument } from 'views/DocumentLibrary/types';

interface UseGetTimelineDocumentsParams {
    timelineId: number;
    orgId: string;
    dealId: number;
    enabled?: boolean;
}

const getTimelineDocuments = async (orgId: string, dealId: number, timelineId: number): Promise<IDealDocument[]> => {
    const response = await axiosInstance.get(API_ENDPOINTS.TIMELINE_DOCUMENTS(orgId, dealId, timelineId));
    return response.data;
};

export const useGetTimelineDocuments = ({
    orgId,
    dealId,
    timelineId,
    enabled = true,
}: UseGetTimelineDocumentsParams) => useQuery({
    queryKey: [QUERY_KEYS.TIMELINE_DOCUMENTS, orgId, dealId, timelineId],
    queryFn: () => getTimelineDocuments(orgId, dealId, timelineId),
    enabled,
});

export default useGetTimelineDocuments;
